/**
 * Fait défiler la page jusqu'à la section `id` et met l'ancre dans l'URL, sans passer par le routeur.
 *
 * Pourquoi : le défilement automatique du routeur (`anchorScrolling`) ne s'exécute qu'une fois l'application « stable » ;
 * tant que des tâches restent en attente il ne fait rien, et les liens du sommaire (Conditions, Confidentialité) ne
 * menaient nulle part. Ici le défilement est direct. Retourne `false` si la section n'existe pas.
 */
export function scrollToSection(id: string, doc: Document = document, win: Window = window): boolean {
  const target = doc.getElementById(id);
  if (!target) return false;
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  win.history.replaceState(win.history.state, '', `${win.location.pathname}${win.location.search}#${id}`);
  return true;
}
